import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  getsistemasHabilitadosPortalCidadao() {
    return http.get(
      `${commonRoute}/SistemaExterno/sistemasHabilitadosPortalCidadao/noauth`
    );
  },
  getModulosAtivosByIdSistema() {
    const alias = "RedeSIM";
    return http.get(
      `${commonRoute}/SistemaExterno/modulosAtivosByAlias/${alias}/noauth`
    );
  },
};

export default apiDef;
